/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  McpEnvironmentConfigInput,
  McpEnvironmentConfigInput$Outbound,
  McpEnvironmentConfigInput$outboundSchema,
} from "./mcpenvironmentconfiginput.js";

export type SetMcpMetadataRequestBody = {
  /**
   * The default environment to load variables from. Not supported when mcp_server_id is provided.
   */
  defaultEnvironmentId?: string | undefined;
  /**
   * The list of environment variables to configure for this MCP
   */
  environmentConfigs?: Array<McpEnvironmentConfigInput> | undefined;
  /**
   * A blob of text for the button on the MCP server page
   */
  externalDocumentationText?: string | undefined;
  /**
   * A link to external documentation for the MCP install page
   */
  externalDocumentationUrl?: string | undefined;
  /**
   * URL to redirect to instead of showing the default installation page
   */
  installationOverrideUrl?: string | undefined;
  /**
   * Server instructions returned in the MCP initialize response
   */
  instructions?: string | undefined;
  /**
   * The asset ID for the MCP install page logo
   */
  logoAssetId?: string | undefined;
  /**
   * The ID of the MCP server associated with this install page metadata. Mutually exclusive with toolset_slug.
   */
  mcpServerId?: string | undefined;
  /**
   * The slug of the toolset associated with this install page metadata. Mutually exclusive with mcp_server_id.
   */
  toolsetSlug?: string | undefined;
};

/** @internal */
export type SetMcpMetadataRequestBody$Outbound = {
  default_environment_id?: string | undefined;
  environment_configs?: Array<McpEnvironmentConfigInput$Outbound> | undefined;
  external_documentation_text?: string | undefined;
  external_documentation_url?: string | undefined;
  installation_override_url?: string | undefined;
  instructions?: string | undefined;
  logo_asset_id?: string | undefined;
  mcp_server_id?: string | undefined;
  toolset_slug?: string | undefined;
};

/** @internal */
export const SetMcpMetadataRequestBody$outboundSchema: z.ZodMiniType<
  SetMcpMetadataRequestBody$Outbound,
  SetMcpMetadataRequestBody
> = z.pipe(
  z.object({
    defaultEnvironmentId: z.optional(z.string()),
    environmentConfigs: z.optional(
      z.array(McpEnvironmentConfigInput$outboundSchema),
    ),
    externalDocumentationText: z.optional(z.string()),
    externalDocumentationUrl: z.optional(z.string()),
    installationOverrideUrl: z.optional(z.string()),
    instructions: z.optional(z.string()),
    logoAssetId: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
    toolsetSlug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      defaultEnvironmentId: "default_environment_id",
      environmentConfigs: "environment_configs",
      externalDocumentationText: "external_documentation_text",
      externalDocumentationUrl: "external_documentation_url",
      installationOverrideUrl: "installation_override_url",
      logoAssetId: "logo_asset_id",
      mcpServerId: "mcp_server_id",
      toolsetSlug: "toolset_slug",
    });
  }),
);

export function setMcpMetadataRequestBodyToJSON(
  setMcpMetadataRequestBody: SetMcpMetadataRequestBody,
): string {
  return JSON.stringify(
    SetMcpMetadataRequestBody$outboundSchema.parse(setMcpMetadataRequestBody),
  );
}
